export const ROOT_NDC = 'ndc9#';

export const notation = (id) => {
  if (id) {
    return id.replace(ROOT_NDC, '');
  }
  return id;
};



// WEBPACK FOOTER //
// ./src/utils.js